import { Component, computed, input } from '@angular/core';
import { WebsiteHrefPipe } from '../../core/website-href.pipe';

/** The school form fields the summary step shows. */
export interface SchoolSummary {
  schoolType?: string | null;
  institutionId?: string | null;
  countEmployees?: number | string | null;
  countStudents?: number | string | null;
  schoolZipcode?: string | null;
  schoolCity?: string | null;
  schoolStreet?: string | null;
  website?: string | null;
  about?: string | null;
  levels?: readonly string[] | null;
  contactName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
}

@Component({
  selector: 'app-school-summary-card',
  standalone: true,
  imports: [WebsiteHrefPipe],
  templateUrl: './school-summary-card.component.html',
})
export class SchoolSummaryCardComponent {
  title = input<string | null>();
  summary = input.required<SchoolSummary>();
  institutionName = input<string | null>();
  /** Optional line under the title, e.g. the school type. */
  subtitle = input<string | null>();

  town = computed(() =>
    [this.summary().schoolZipcode, this.summary().schoolCity]
      .map(part => String(part ?? '').trim())
      .filter(Boolean)
      .join(' ')
  );

  address = computed(() =>
    [this.town(), String(this.summary().schoolStreet ?? '').trim()]
      .filter(Boolean)
      .join(', ')
  );

  levels = computed(() => {
    const levels = this.summary().levels;
    return Array.isArray(levels) ? levels : [];
  });
}
